import Cookies from "js-cookie";
import { DEFAULT_URL } from "../constants";

// User details
export const userEmail = Cookies.get("email") || "";
export const defaultUrl = Cookies.get("preferred_url") || DEFAULT_URL;
